import React, { FC, useEffect } from 'react';
import { Dialog } from '@rbx/ui';
import unifiedLoggerClient from '@modules/eventStream/implementations/unifiedLoggerClient';
import { useTranslation } from '@rbx/intl';
import useCurrentLocale from '@modules/localization/hooks/useCurrentLocale';
import TDialogTemplate from '@modules/miscellaneous/common/components/TDialogTemplate';

interface IncompatibleStudioPlatformDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const IncompatibleStudioPlatformDialog: FC<
  React.PropsWithChildren<IncompatibleStudioPlatformDialogProps>
> = ({ open, setOpen }) => {
  const { urlLocale } = useCurrentLocale();
  const { translate } = useTranslation();
  const onClose = () => setOpen(false);

  useEffect(() => {
    if (open) {
      unifiedLoggerClient.logImpressionEvent({
        eventName: 'IncompatibleStudioPlatformDialogImpression',
        parameters: {
          locale: urlLocale ? String(urlLocale) : '',
        },
      });
    }
  }, [urlLocale, open]);

  return (
    <Dialog open={open} maxWidth='XLarge' onClose={onClose}>
      <TDialogTemplate
        title={translate('Label.StudioNotAvailable')}
        content={translate('Message.NotStudioCompatiblePlatformDownload')}
        variant='center'
        confirmText={translate('Action.Close')}
        onConfirm={onClose}
      />
    </Dialog>
  );
};

export default IncompatibleStudioPlatformDialog;
